<template>
    <v-card v-bind="$attrs" flat color="transparent" v-on="$listeners">
        <v-text-field
            v-model="serialValue"
            data-cy="input-serial-field"
            label="Input Serial #"
            class="serial-validator pr-4"
            outlined
            v-bind="$attrs"
            v-on="$listeners"
            @input="verifySerial"
        >
            <template v-slot:append-outer>
                <v-card v-if="callingApi" flat width="24" height="24" color="transparent">
                    <v-progress-circular width="2" size="20" color="secondary" indeterminate></v-progress-circular>
                </v-card>
                <v-card v-else width="24" height="24" color="transparent" flat>
                    <v-card
                        v-if="serialNotFound"
                        flat
                        data-cy="serial-not-found-icon"
                        color="transparent"
                        width="24"
                        height="24"
                    >
                        <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                                <v-icon color="error" dark v-bind="attrs" v-on="on">
                                    {{ mdiAlertCircleOutline }}
                                </v-icon>
                            </template>
                            <span>Serial Not Found</span>
                        </v-tooltip>
                    </v-card>
                    <v-card
                        v-else-if="!serialIsValid && serialValue && serialValue.length >= 10"
                        data-cy="serial-not-valid-icon"
                        flat
                        color="transparent"
                        width="24"
                        height="24"
                    >
                        <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                                <v-icon color="red" dark v-bind="attrs" v-on="on">
                                    {{ mdiCheckboxMarkedCircleOutline }}
                                </v-icon>
                            </template>
                            <span>Serial not valid for new RMA</span>
                        </v-tooltip>
                    </v-card>
                    <v-card
                        v-else-if="serialIsValid"
                        data-cy="serial-valid-icon"
                        flat
                        color="transparent"
                        width="24"
                        height="24"
                    >
                        <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                                <v-icon color="green" dark v-bind="attrs" v-on="on">
                                    {{ mdiCheckboxMarkedCircleOutline }}
                                </v-icon>
                            </template>
                            <span>Serial valid for new RMA!</span>
                        </v-tooltip>
                    </v-card>
                    <v-card v-else data-cy="serial-not-input-icon" flat color="transparent" width="24" height="24" />
                </v-card>
            </template>
        </v-text-field>
    </v-card>
</template>
<script>
import { verifySerialForRma, queryCommonConfig } from '@/api'
import { mdiAlertCircleOutline, mdiCheckboxMarkedCircleOutline, mdiCancel } from '@mdi/js'
export default {
    name: `ValidateWarranty`,

    props: {
        outsideSerial: {
            type: String,
            default: ``
        }
    },

    data() {
        return {
            callingApi: false,
            mdiCheckboxMarkedCircleOutline,
            mdiAlertCircleOutline,
            mdiCancel,
            inputSerial: ``,
            serialValue: ``,
            serialData: {}
        }
    },

    computed: {
        serialNotFound() {
            return !!(
                this.serialValue &&
                !Object.keys(this.serialData).includes(`iw`) &&
                !Object.keys(this.serialData).includes(`rmaExists`)
            )
        },
        serialIsValid() {
            return (
                (!!(this.serialData.serial && !this.serialData.rmaExists) || !!this.serialData.allowOow) &&
                !this.serialData.isEOS &&
                this.serialData.model !== 'EX80'
            )
        }
    },

    mounted() {
        if (this.outsideSerial) {
            this.serialValue = this.outsideSerial
        }
        this.verifySerial(this.serialValue)
    },

    methods: {
        async verifySerial(serial) {
            this.serialData = {}
            if (serial && serial.length >= 9) {
                this.callingApi = true
                try {
                    const normalizedSerial = serial.toUpperCase().trim()
                    const { data } = await verifySerialForRma({
                        serial: normalizedSerial
                    })

                    let commonConfigData = await queryCommonConfig({
                        configName: `PCG_SERIALS`
                    })
                    if (commonConfigData.data) {
                        commonConfigData = commonConfigData.data
                    }

                    const configResult = Array.isArray(commonConfigData?.result) ? commonConfigData.result : []
                    const pcgSerial = configResult.some((item) => item === normalizedSerial)

                    const serialData = data.constructor.name === `Object` ? data : {}

                    this.serialData = { ...serialData, pcgSerial }
                } catch (error) {
                    console.error(error)
                } finally {
                    this.callingApi = false
                }
            }
            this.$emit(`isValid`, this.serialIsValid)
            this.$emit(`serialData`, this.serialData)
        }
    }
}
</script>
<style lang="scss">
.serial-validator {
    input {
        text-transform: uppercase;
    }
}
</style>
